import React, {createContext, useContext} from 'react';

// TODO(WB-29718): Remove this once the feature rollout completes.
const ImprovedRunLogsPaginationContext = createContext<boolean>(false);

export const ImprovedRunLogsPaginationProvider: React.FC<{
  children: React.ReactNode;
  useImprovedRunLogsPagination: boolean;
}> = ({children, useImprovedRunLogsPagination}) => {
  return (
    <ImprovedRunLogsPaginationContext.Provider
      value={useImprovedRunLogsPagination}>
      {children}
    </ImprovedRunLogsPaginationContext.Provider>
  );
};

/**
 * useImprovedRunLogPagination checks whether the improved run log pagination
 * feature is enabled.
 */
export const useImprovedRunLogPagination = (): boolean => {
  return useContext(ImprovedRunLogsPaginationContext);
};
